// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const NavigateContext = createContext()

export const NavigateContextProvider = ({children}) => {
    const [navigateContext, setNavigateContext] = useState('')

    return (
        <NavigateContext.Provider value={{navigateContext, setNavigateContext}}>
            { children }
        </NavigateContext.Provider>
    )
}